// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getAudits} from '../../shared/repositories';

export const readAudits = selectedDealers =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const accountsArray = typeof selectedDealers === 'string' ? [selectedDealers] : selectedDealers;
            const data = await getAudits(accountsArray);

            dispatch({
                data,
                type: actions.UPDATE_TCSM_AUDIT_LIST
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/audits/action-creators/get-audits.js